import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormTextFieldPdf from '../../common/Forms/FormTextFieldPdf';

export const referralNoteField = (label, defaultValue) => {
  return (
    <>
      <Box my={2}></Box>
      <Grid item xs={11.9}>
        <TextField
          sx={{ width: '100%' }}
          label={label}
          multiline
          disabled
          rows={4}
          defaultValue={defaultValue}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </>
  );
};

export const stopResponseSubGrid = (title) => {
  return (
    <Grid item xs={6}>
      {title}
    </Grid>
  );
};

export const referalPageCardHeading = (headingTitle) => {
  return (
    <Grid container item xs={12}>
      <Typography variant="h6" fontWeight="800">
        {headingTitle}
      </Typography>
    </Grid>
  );
};

export const ReferralFieldGrid = ({ xs, title, defaultValue }) => {
  return (
    <Grid item xs={xs}>
      <FormTextFieldPdf title={title} defaultValue={defaultValue} />
    </Grid>
  );
};
